import React from "react";
import Avatar from "react-avatar";
import styles from "../../component/mainAdmin/stdassignmentsidebar.module.css";
import {useDispatch} from 'react-redux'
import {showsinglestdass} from "../../Redux/action/adminassignment/showsinglestdass"


function Stdassignmentssidebar({ data,totalMarks,assignementName }) {

  const dispatch = useDispatch()

  return (
    <div
      style={{ height: "83vh",overflowY: "auto", width: "35vw", border: "2px solid green" }}
    >
      <div className={`${styles.mainchip} ${styles.green}`}>
              <div
                style={{
                  display: "flex",
                //   justifyContent: "center",
                  alignItems: "center",
                  width:'60%',
                  marginLeft:5
                }}
              >
                <Avatar
                  name={'Admin'}
                  round={true}
                  size={50}
                  color="#fff"
                  fgColor="green"
                  style={{ marginRight: 10,color:"#000" }}
                />
                <h4 style={{color:'#fff'}}>All Students</h4>
              </div>
              <h4 style={{width:'30%',color:'#fff'}}>Total Marks {totalMarks}</h4>
            </div>
      {data &&
        data.map((e, i) => {
          return (
            <div className={styles.mainchip} onClick={() => dispatch(showsinglestdass(e))} key={i}>
              <div
                style={{
                  display: "flex",
                //   justifyContent: "center",
                  alignItems: "center",
                  width:'85%',
                  marginLeft:5
                }}
              >
                <Avatar
                  name={e.stdName}
                  round={true}
                  size={50}
                  color="green"
                  style={{ marginRight: 10 }}
                />
                <h4>{e.stdName}</h4>
              </div>
              {/* <h2 style={{width:'15%',backgroundColor:"revert"}}>0/30-</h2> */}
            </div>
          );
        })}
    </div>
  );
}

export default Stdassignmentssidebar;
